import {
    AccountMergeStatus,
    PreviewAccountOrigin,
} from "@common/types/domains/accounting/chartOfAccountsTemplateApply";
import {
    ChartOfAccountsTemplateAccount,
    ChartOfAccountsTemplateAccountGroup,
} from "@common/types/domains/accounting/chartOfAccountsTemplateAccount";
import {
    ChartOfAccountsTemplatePreviewEntity,
    PreviewGroup,
} from "@common/schemas/chart-of-accounts-template-apply.schema";

function toPreviewGroups(
    groups: ReadonlyArray<{
        id: string;
        name: string;
        type: string;
        parentGroupId: string | null;
    }>,
): PreviewGroup[] {
    return groups.map((group) => ({
        id: group.id,
        name: group.name,
        type: group.type,
        parentGroupId: group.parentGroupId,
        isNew: false,
        origin: PreviewAccountOrigin.entityOnly,
    }));
}

// Every account is `unchanged` so the preview renders no merge badges. Templates
// carry no subtype/class — the preview re-derives class from type, so the empty
// strings are safe. Variable rows (null code) are included; the preview handles null.
export function templateToPreviewEntity({
    entityId,
    accounts,
    groups,
}: {
    entityId: number;
    accounts: ChartOfAccountsTemplateAccount[];
    groups: ChartOfAccountsTemplateAccountGroup[];
}): ChartOfAccountsTemplatePreviewEntity {
    return {
        entityId,
        accounts: accounts.map((account) => ({
            id: account.id,
            code: account.code,
            codeText: account.codeText,
            name: account.name,
            previousCode: null,
            type: account.type,
            subtype: "",
            class: "",
            isDisabled: account.isDisabled,
            isManuallyCreated: account.isManuallyCreated,
            parentGroupId: account.parentGroupId,
            mergeStatus: AccountMergeStatus.unchanged,
            sortOrder: account.sortOrder,
            // This preview shows a chart as-is (no template<>entity diff), so
            // no origin/change badges apply.
            origin: PreviewAccountOrigin.entityOnly,
            changes: [],
            wasArchivedByApply: false,
            previousGroupPath: null,
        })),
        groups: toPreviewGroups(groups),
    };
}
